exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".h20{height:20px}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/components/problemTable/problemTable.vue"],"names":[],"mappings":"AACA,KACE,WAAa,CACd","file":"problemTable.vue","sourcesContent":["\n.h20{\n  height: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cc08100e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/problemTable/problemTable.vue
// module id = 587
// module chunks = 2